(function () {
  'use strict';

  angular.module('app').component('toursPage', tourListCtrl());

  function tourListCtrl() {
    return {
      bindings: {},
      controller: TourListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tours/tours-page.component.html',
    };
  }

  TourListCtrl.$inject = [
    '$location',
    'AbilityService',
    'SessionService',
    'TourService',
    'LanguageService',
  ];

  function TourListCtrl($location, AbilityService, SessionService, TourService, LanguageService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_tour_accountadmin'),
    };

    vm.userLanguageCode = SessionService.getUserLanguage().code;

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getTours();
      });
    }

    function getTours() {
      let filterCriteria = TourService.getFilterCriteria();
      // filterCriteria.lang = vm.defaultLanguage;
      // filterCriteria.lang = vm.userLanguageCode;

      vm.loadingItems = true;
      TourService.getTours(filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/tours/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/tours/${item.id}`).search({ mode: mode });
    }
  }
})();
